import * as t from "./actionTypes";

export const videoTourInstanceAdded = instanceId => ({
	type: t.VIDEO_TOUR_INSTANCE_ADDED,
	payload: { instanceId }
});

export const videoTourInstanceRemoved = instanceId => ({
	type: t.VIDEO_TOUR_INSTANCE_REMOVED,
	payload: { instanceId }
});

export const setVideoTourClockTicks = ticks => ({
	type: t.SET_VIDEO_TOUR_CLOCK_TICKS,
	payload: { ticks }
});
